import React, { useMemo } from 'react';
import { buildProduct, ProductDefinitions } from './productsUtil';
import ProfileSelectionCard from './ProfileSelectionCard';

/**
 * Component for displaying specialized testing profiles (CNA, MethylDetox, CICA, Histamine, Telomere) 
 * as selection cards in a grid.
 */
const SpecializedTesting = ({ orderableItem, onSelection, selectedComponents }) => {
	// Merge product definitions with the orderable item to set input field ids and filter out inactive products
	const products = useMemo(() => {
		return [
			buildProduct({ productDefinition: ProductDefinitions.CNA, orderableItem }),
			buildProduct({ productDefinition: ProductDefinitions.MethylDetox, orderableItem }),
			buildProduct({ productDefinition: ProductDefinitions.CICA, orderableItem }),
			buildProduct({ productDefinition: ProductDefinitions.Histamine, orderableItem }),
			buildProduct({ productDefinition: ProductDefinitions.Telomere, orderableItem }),
			buildProduct({ productDefinition: ProductDefinitions.ComprehensiveDelayedHypersensitivity, orderableItem }),
			buildProduct({ productDefinition: ProductDefinitions.ComprehensiveDelayedFoodPanel, orderableItem })
		].filter(Boolean);
	}, [orderableItem]);

	if (!products?.length) {
		return null;
	}

	return (
		<div>
			<h3>Specialized testing profiles</h3>
			<div className="css-product-grid" style={{ fontSize: '.875em' }}>
				{products.map((product) => (
					<ProfileSelectionCard
						key={product.inputFieldId}
						profile={product}
						onSelection={onSelection}
						selectedComponents={selectedComponents}
						header={product.header}
						footer={null}
					/>
				))}
			</div>
		</div>
	);
};

export default SpecializedTesting;
